import { Navigation } from 'components';
import styles from './AppBar.module.css';

export const AppBar = () => (
  <header className={styles.container}>
    <Navigation />
  </header>
);
